<div class="processing-backdrop" role="status" aria-live="polite" aria-label="Running detection">

  <!-- Centered modal card -->
  <div class="processing-card text-center">

    <h3 class="mat-font-title-md fw-semibold mb-1">Running detection…</h3>
    <p class="mat-font-body-sm mb-3">
      Analyzing imagery within the selected area.
    </p>

    <!-- Object chips — tonal bg in object color -->
    @if (detection.objects().length > 0) {
      <div class="d-flex flex-wrap gap-2 justify-content-center mb-3">
        @for (obj of detection.objects(); track obj.name) {
          <span class="obj-chip mat-font-label-md px-2 py-1"
                [style.--obj-color]="obj.color">
            {{ obj.name }}
          </span>
        }
      </div>
    }

    <!-- Progress bar -->
    <mat-progress-bar
      mode="determinate"
      [value]="detection.progress()"
      color="primary"
      class="mb-2" />

    <!-- Timer / percentage row -->
    <div class="d-flex justify-content-between mat-font-body-sm mb-3">
      <span>{{ detection.progress() | number:'1.0-0' }}%</span>
    </div>

    <button matButton="outlined"
            type="button"
            class="w-100"
            (click)="detection.cancelRun()">
      <mat-icon>close</mat-icon> Cancel detection
    </button>

  </div>

</div>
